export default {
  doNotRemove: [
    "dynamicColumnSurgery",
    "dynamicColumnPharmacy",
    "dynamicColumnStaff",
    "dynamicColumnUnCollected",
    "dynamicColumnCollected",
    "dynamicColumnPatient",
    "dynamicColumnRepeatOrder",
    "dynamicColumnSequenceStaff",
    "dynamicColumnSequenceSurgery",
    "dynamicColumnSequenceUnCollected",
    "dynamicColumnSequencePharmacy",
    "dynamicColumnSequencePatient",
    "dynamicColumnSequenceCollected",
    "dynamicColumnSequenceRepeatOrder",
    "pinSideDrawer",
    "LogoutFromFunc",
    "logOutFromInterceptor",
    "LastDailogAt",
    "LogOutFromButton"
  ],
};
